import React from "react";
import Button from "components/button";
import Icon from "components/icon";
import ActionMenu from "components/shared/action-menu";
import { FleetRow } from "../types";

export const PlateNumberCell = ({ row }: { row: FleetRow }) => (
  <div className="flex items-center gap-3 group">
    <div className="h-10 w-10 overflow-hidden rounded-full bg-greyScale-100 border border-border group-hover:border-primary-500 transition-colors">
      <img src={row.fleetPicture || "https://placehold.co/400x400?text=No+Image"} alt={row.plateNumber} className="h-full w-full object-cover" />
    </div>
    <div className="flex flex-col">
      <span className="font-bold text-sm text-slate-900 group-hover:text-primary-600 transition-colors">{row.plateNumber}</span>
    </div>
  </div>
);

export const StatusCell = ({ row, t }: { row: FleetRow, t: any }) => {
  const statusStyles: Record<string, string> = {
    Available: "bg-[#F0FDF4] text-[#166534]",
    Assigned: "bg-[#FFFBEB] text-[#92400E]",
    Maintenance: "bg-[#FEF2F2] text-[#991B1B]",
    Inactive: "bg-[#F8FAFC] text-[#475569]",
  };
  const style = statusStyles[row.status] || "bg-greyScale-100 text-greyScale-600";
  return (
    <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${style}`}>
      {t(`status-${row.status.toLowerCase()}` as any)}
    </div>
  );
};

export const ActionCell = ({ 
  row, 
  t, 
  handleEditRequest,
  handleToggleStatus, 
  handleDeleteRequest 
}: { 
  row: FleetRow, 
  t: any, 
  handleEditRequest: (id: string) => void,
  handleToggleStatus: (row: FleetRow, status: string) => void,
  handleDeleteRequest: (row: FleetRow) => void
}) => (
  <div className="flex items-center gap-2" onClick={(event) => event.stopPropagation()}>
    <Button
      type="button"
      variant="outline"
      color="tertiary"
      size="small"
      iconLeft={<Icon name="edit-2" size={14} />}
      onClick={() => handleEditRequest(row.id)}
      className="px-3"
    >
      {t("btn-edit")}
    </Button>
    <ActionMenu
      items={[
        ...(row.status === "Available"
          ? [
              { label: t("btn-deactivate"), onClick: () => handleToggleStatus(row, "Inactive") },
              { label: t("bulk-action-maintenance"), onClick: () => handleToggleStatus(row, "Maintenance") },
            ]
          : []),
        ...(row.status === "Inactive"
          ? [
              { label: t("btn-activate"), onClick: () => handleToggleStatus(row, "Available") },
              { label: t("bulk-action-maintenance"), onClick: () => handleToggleStatus(row, "Maintenance") },
              { label: t("btn-delete"), onClick: () => handleDeleteRequest(row), variant: "danger" as const },
            ]
          : []),
        ...(row.status === "Maintenance"
          ? [
              { label: t("btn-activate"), onClick: () => handleToggleStatus(row, "Available") },
              { label: t("btn-deactivate"), onClick: () => handleToggleStatus(row, "Inactive") },
            ]
          : []),
      ]}
    />
  </div>
);
